<template>
  <div :class="[$style.container, { [$style.active]: loading }]">
    <slot v-show="!loading" />

    <div
      ref="overlay"
      v-show="loading"
      :class="$style.overlay"
    >
      <div v-if="getLogoLink" :class="$style.logo">
        <img :src="getLogoLink" alt="logo" />
      </div>

      <div :class="$style.progress" />
      <div :class="$style.text" v-text="$t('wait.please')" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PreloaderOverlay',
  props: {
    loading: Boolean,
  },
  computed: {
    ...mapGetters([
      'getLogoLink',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    +size(100vw, 100vh)
    +font-type('regular', 14, 17)
    position: relative
    color: #212121

  .overlay
    +flexbox
    +flex-direction(column)
    +justify-content(center)
    +align-items(center)
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: #FFF
    z-index: 1000

  .logo
    +size(164px, 114px)
    margin-bottom: 40px

    img
      width: 100%

  .progress
    +size(90px, 5px)
    position: relative
    margin-bottom: 50px
    background-color: #E0E0E0
    border-radius: 10px
    overflow: hidden

    &:before
      +size(36px, 100%)
      content: ''
      position: absolute
      top: 0
      bottom: 0
      background-color: #616161
      border-radius: 10px
      animation-name: increase
      animation-duration: 1.5s
      animation-iteration-count: infinite
      animation-timing-function: ease-in-out

  @keyframes increase
    from
      left: -100%
    to
      left: 100%
</style>
